import { footerStyles } from "@insite/content-library/Pages/Footer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

footerStyles.page = {
    fullWidth: [true, true, true, true, true],
    padding: 0,
    background: "primary",
    css: css`
        /* background: transparent linear-gradient(180deg, #cccfe0 0%, #fdfefe 48%, #ffffff 100%) 0% 0% no-repeat
            padding-box; */
        /* background-color: ; */
        margin-top: 5rem;
        position: relative;
        top: 128px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 15px 1.5rem;
                    position: unset;
                    top: 0px;
                `,
                css`
                    padding: 15px 1.5rem;
                    position: unset;
                    top: 0px;
                `,
                css`
                    position: relative;
                    top: 124px;
                `,
                null,
                null,
            ])}
    `,
};
